import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextArea, Typography } from "@/components/atoms";
import { useCountryConfig, useOperator } from "@/hooks";
import { clsx } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const BusinessAddressField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();
  const { country: operatorCountry } = useOperator();
  const country = watch("countryCode") ?? operatorCountry;

  // Live config (API over bundle) rather than the deprecated bundled-only getter, so a country the
  // API knows but the bundle does not still gets its own postal label.
  const { config } = useCountryConfig(country);
  const postalLabel = config.postalLabel;

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Business Address (Inc {postalLabel})</Typography>
      <TextArea
        className="w-full"
        placeholder="Enter Business Address"
        maxLength={128}
        hasError={!!errors.businessAddress}
        {...register("businessAddress")}
      />
      <ErrorMessage errors={errors} name="businessAddress" />
    </div>
  );
};
